<!-- Filtros de Atenciones -->
<div class="flex-row flex-100">
    <div class="flex-column gap-10px" style="width: 100%;">

        @if(this.optionSelected == 'calendario'){
        <app-calendar-case class="flex-100" (onEventClicked)="this.onEventClickedHandler($event)"
            (onEventDelete)="onClickDeleteAttention($event)" [loading]="this.loadingInnerCalendar"
            (onDayClicked)="this.onClickCreateAttention($event)" [colorsForAgreements]="colorsForAgreements"
            [attentions]="this.filteredAttentions" [optionSelected]="this.optionSelected"
            (option)="this.receiveOptionSelected($event)" (onClickCreateAttention)="createAttentionFromOUT($event)"
            (viewSelected)="this.setViewSelectedCalendarCase($event)" [fromProviderSchedule]="fromProviderSchedule">
        </app-calendar-case>
        }

        @if(optionSelected === 'listado' && isModulesFlow){
        <!-- MODULES ATTENTIONS -->
        <!-- [columnsToShow]="this.viewColumnsBillAndDebit ? this.displayColumnsForAttentions : ['fromDate', 'isAuthorized', 'timeRange', 'hours', 'practice', 'provider', 'state', 'actionsMenu']" -->
        <app-modules-attentions-list-case class="flex-100"
            [textNoAttentions]="'No existen atenciones para el mes indicado'" [showGoToCase]="false"
            [showProviderPracticeFilter]="true" [providers]="this.filterCaseProviders()"
            [ruleClickable]="this.attentionsService.isDeletable"
            (onClickButton4)="this.viewColumnsBillAndDebit ? this.onClicProcessBillAndDebit($event) : ''"
            [colorButton4]="'primary'" [textButton4]="this.viewColumnsBillAndDebit ? 'PROCESAR' : ''"
            [descriptionStateShort]="true" [bottomTotals]="true" [columnsToShow]="this.displayColumnsForAttentions"
            [attentions]="this.moduleAttentions" (onUpdateClicked)="this.receiveEventUpdate($event)"
            (onDeleteClicked)="this.receiveEventDelete($event)" [attentionsWithOverlap]="this.attentionsWithOverlap"
            (option)="this.receiveOptionSelected($event)" [optionSelected]="this.optionSelected"
            (onClickCreateAttention)="createAttentionFromOUT($event)"
            [processSuccessOnAttentions]="this.processSuccessOnAttentions ?? false"
            (statesAttentionSelectedEmitter)="receiveStateAttentionsSelected($event)"
            [statesAttentionsSelectedInput]="stateAttentionSelected"
            [loading]="this.isLoadingGetAttentions || this.isLoadingGettingEvolutions || this.isLoadingFilteredAttentions"
            [provisionsFilteredCount]="this.provisionsFilteredCount"
            [provisionsSuppliesFilteredCount]="this.provisionsSuppliesFilteredCount"
            [ordersFilteredCount]="this.ordersFilteredCount"
            [provisionAgreements]="this.provisionAgreementsInput?.agreements ?? this.provisionAgreements"
            [provisionFees]="this.provisionAgreementsInput.provisionFees" [showMonth]="false"
            [selectedOption]="this.selectedOption" [focusToElement]="focusEmitter"
            [caseModuleSelected]="this.selectedCaseModuleFromParent" [ordersRadioSelected]="this.ordersRadioSelected"
            [viewColumnsBillAndDebit]="this.viewColumnsBillAndDebit">
        </app-modules-attentions-list-case>
        @if(practiceModuleAttentions?.length > 0){
        <!-- PRACTICE MODULE ATTENTIONS -->
        <!-- [columnsToShow]="this.viewColumnsBillAndDebit ? this.displayColumnsForAttentions : ['fromDate', 'isAuthorized', 'timeRange', 'hours', 'practice', 'provider', 'state', 'actionsMenu']" -->
        <app-attentions-list-case class="flex-100" [textNoAttentions]="'No existen atenciones para el mes indicado'"
            [showGoToCase]="false" [showProviderPracticeFilter]="true" [providers]="this.filterCaseProviders()"
            [ruleClickable]="this.attentionsService.isDeletable"
            (onClickButton4)="this.viewColumnsBillAndDebit ? this.onClicProcessBillAndDebit($event) : ''"
            [colorButton4]="'primary'" [textButton4]="this.viewColumnsBillAndDebit ? 'PROCESAR' : ''"
            [descriptionStateShort]="true" [bottomTotals]="true" [columnsToShow]="this.displayColumnsForAttentions"
            [attentions]="this.practiceModuleAttentions" (onUpdateClicked)="this.receiveEventUpdate($event)"
            (onDeleteClicked)="this.receiveEventDelete($event)" [attentionsWithOverlap]="this.attentionsWithOverlap"
            (option)="this.receiveOptionSelected($event)" [optionSelected]="this.optionSelected"
            (onClickCreateAttention)="createAttentionFromOUT($event)"
            [processSuccessOnAttentions]="this.processSuccessOnAttentions ?? false"
            (statesAttentionSelectedEmitter)="receiveStateAttentionsSelected($event)"
            [statesAttentionsSelectedInput]="stateAttentionSelected"
            [loading]="this.isLoadingGetAttentions || this.isLoadingGettingEvolutions || this.isLoadingFilteredAttentions"
            [provisionsFilteredCount]="this.provisionsFilteredCount"
            [provisionsSuppliesFilteredCount]="this.provisionsSuppliesFilteredCount"
            [ordersFilteredCount]="this.ordersFilteredCount"
            [provisionAgreements]="this.provisionAgreementsInput?.agreements ?? this.provisionAgreements"
            [provisionFees]="this.provisionAgreementsInput.provisionFees" [showMonth]="false"
            [selectedOption]="this.selectedOption" [focusToElement]="focusEmitter"
            [viewColumnsBillAndDebit]="this.viewColumnsBillAndDebit">
        </app-attentions-list-case>
        }

        @if(!viewColumnsBillAndDebit && orderModuleAttentions?.length > 0 || viewColumnsBillAndDebit &&
        supplyModuleAttentions?.length > 0) {
        <!-- ORDER MODULE ATTENTIONS -->
        <!-- [columnsToShow]="this.viewColumnsBillAndDebit ? this.displayColumnsForAttentionsSupplies : ['fromDate', 'isAuthorized', 'timeRange', 'hours', 'practice', 'provider', 'state', 'actionsMenu']" -->
        <app-attentions-list-case class="flex-100" [textNoAttentions]="'No existen atenciones para el mes indicado'"
            [showGoToCase]="false" [showProviderPracticeFilter]="true" [providers]="this.filterCaseProviders()"
            [ruleClickable]="this.attentionsService.isDeletable"
            (onClickButton4)="this.viewColumnsBillAndDebit ? this.onClicProcessBillAndDebit($event) : ''"
            [colorButton4]="'primary'" [textButton4]="this.viewColumnsBillAndDebit ? 'PROCESAR' : ''"
            [descriptionStateShort]="true" [bottomTotals]="true"
            [title]="viewColumnsBillAndDebit? 'Insumos' : 'Pedidos'"
            [columnsToShow]="this.displayColumnsForAttentionsSupplies"
            [attentions]="this.viewColumnsBillAndDebit ? this.supplyModuleAttentions : this.orderModuleAttentions"
            (onUpdateClicked)="this.receiveEventUpdate($event)" (onDeleteClicked)="this.receiveEventDelete($event)"
            [attentionsWithOverlap]="this.attentionsWithOverlap" (option)="this.receiveOptionSelected($event)"
            [optionSelected]="this.optionSelected" (onClickCreateAttention)="createAttentionFromOUT($event)"
            [processSuccessOnAttentions]="this.processSuccessOnAttentions ?? false"
            (statesAttentionSelectedEmitter)="receiveStateAttentionsSelected($event)"
            [statesAttentionsSelectedInput]="stateAttentionSelected"
            [loading]="this.isLoadingGetAttentions || this.isLoadingGettingEvolutions || this.isLoadingFilteredAttentions"
            [provisionsFilteredCount]="this.provisionsFilteredCount"
            [provisionsSuppliesFilteredCount]="this.provisionsSuppliesFilteredCount"
            [ordersFilteredCount]="this.ordersFilteredCount"
            [provisionAgreements]="this.provisionAgreementsInput?.agreements ?? this.provisionAgreements"
            [provisionFees]="this.provisionAgreementsInput.provisionFees" [showMonth]="false"
            [selectedOption]="this.selectedOption" [focusToElement]="focusEmitter"
            [viewColumnsBillAndDebit]="this.viewColumnsBillAndDebit">
        </app-attentions-list-case>
        }

        }@else if(optionSelected === 'listado' && !isModulesFlow) {
        <!-- [columnsToShow]="this.viewColumnsBillAndDebit ? this.displayColumnsForAttentions : ['fromDate', 'isAuthorized', 'timeRange', 'hours', 'practice', 'provider', 'state', 'actionsMenu']" -->
        <app-attentions-list-case class="flex-100" [textNoAttentions]="'No existen atenciones para el mes indicado'"
            [showGoToCase]="false" [showProviderPracticeFilter]="true" [providers]="this.filterCaseProviders()"
            [ruleClickable]="this.attentionsService.isDeletable"
            (onClickButton4)="this.viewColumnsBillAndDebit ? this.onClicProcessBillAndDebit($event) : ''"
            [colorButton4]="'primary'" [textButton4]="this.viewColumnsBillAndDebit ? 'PROCESAR' : ''"
            [descriptionStateShort]="true" [bottomTotals]="true" [columnsToShow]="this.displayColumnsForAttentions"
            [attentions]="this.filteredAttentions" (onUpdateClicked)="this.receiveEventUpdate($event)"
            (onDeleteClicked)="this.receiveEventDelete($event)" [attentionsWithOverlap]="this.attentionsWithOverlap"
            (option)="this.receiveOptionSelected($event)" [optionSelected]="this.optionSelected"
            (onClickCreateAttention)="createAttentionFromOUT($event)"
            [processSuccessOnAttentions]="this.processSuccessOnAttentions ?? false"
            (statesAttentionSelectedEmitter)="receiveStateAttentionsSelected($event)"
            [statesAttentionsSelectedInput]="stateAttentionSelected"
            [loading]="this.isLoadingGetAttentions || this.isLoadingGettingEvolutions || this.isLoadingFilteredAttentions"
            [provisionsFilteredCount]="this.provisionsFilteredCount"
            [provisionsSuppliesFilteredCount]="this.provisionsSuppliesFilteredCount"
            [ordersFilteredCount]="this.ordersFilteredCount"
            [provisionAgreements]="this.provisionAgreementsInput?.agreements ?? this.provisionAgreements"
            [provisionFees]="this.provisionAgreementsInput.provisionFees" [showMonth]="false"
            [selectedOption]="this.selectedOption" [focusToElement]="focusEmitter">
        </app-attentions-list-case>
        }
    </div>
</div>

<div class="spinner-hover" *ngIf="mustShowSpinner()">
    <mat-spinner diameter="60"></mat-spinner>
</div>

<!-- FORM attention Add -->
<ng-template #scheduleDialogTemplate>
    <!-- CLASSIC VIEW -->
    @if(!isModulesFlow){
    <!-- Adding attention -->
    <form class="flex-column flex-100" *ngIf="scheduleForm" [formGroup]="scheduleForm">
        <div class="flex-row flex-100 schedule-case-container">
            <div class="flex-45 align-start-none practice-agreement-container">
                <!-- Select provision_fee -->
                <div class="align-center-none" style="padding: 10px 10px 0px 10px;">
                    <app-select-input [name]="this.PROVISION_FEE" [form]="this.scheduleForm"
                        [placeholder]="'Seleccione la prestación'" [elements]="this.provisionFees"
                        [forceNumber]="this.calculateProvisionFeeId" [calculateId]="this.calculateProvisionFeeId"
                        [calculateName]="this.calculateProvisionFeeName" [disabled]="loadingCreateAttention"
                        (entitySelected)="this.onSelectedProvisionFee( $event )">
                    </app-select-input>
                    <span style="color: #f44336;"
                        *ngIf=" !!this.provisionFeeSelected && this.provisionFeeSelected?.frequency?.amount == null || this.provisionFeeSelected?.frequency?.unit == 'Sin especificar'">La
                        práctica seleccionada no tiene frecuencia, Corrija desde corregir práctica y vuelva a intentar.
                    </span>
                </div>
                <!-- Agreements -->
                <!-- class="agreement-list" -->
                <div class="flex-column agreement-list"
                    *ngIf="this.agreements?.length > 0 && !!this.provisionFeeSelected">
                    <!-- Agreemets header -->
                    <div class="bg-primary-lighter text-primary agreement-header"
                        style="justify-content: space-evenly !important;">
                        <div class="flex-18 align-start-center">
                            <span>Acuerdo prestacional</span>
                        </div>
                        <div class="flex-12 align-start-center">
                            <span>Especialidad</span>
                        </div>
                        <div class="flex-10 align-start-center">
                            <span>Costo</span>
                        </div>
                        <div class="flex-15 align-start-center">
                            <span>Vigencia</span>
                        </div>
                        <!-- Actions -->
                        <div class="flex-15 align-start-center">
                        </div>
                    </div>
                    <!-- Agreements details -->
                    <div class="agreement-information-container"
                        *ngFor="let agreement of this.agreements; trackBy: trackByAgreementId">
                        <!-- Agreement information row -->
                        <div class="flex-row align-start-center agreement-row"
                            [ngClass]="{'bg-primary-lighter': (this.agreementSelected == agreement)}">
                            <!-- Column #1 - Arrow -->
                            <div class="flex-row flex-5 text-primary align-self-stretch"
                                (click)="this.agreementsExpanded.toggle(agreement.id)">
                                <div class="flex-row">
                                    <!-- {{this.colorsForAgreements.get(agreement.id).primary.toString()}} -->
                                    <div [ngStyle]="{'background-color': this.colorsForAgreements?.get(agreement.id)?.primary?.toString()}"
                                        class="flex-15"></div>
                                    <div class="flex-85 flex align-center-center">
                                        <mat-icon
                                            *ngIf="!this.agreementsExpanded.selected.includes(agreement.id)">keyboard_arrow_right</mat-icon>
                                        <mat-icon
                                            *ngIf="this.agreementsExpanded.selected.includes(agreement.id)">keyboard_arrow_down</mat-icon>
                                    </div>
                                </div>
                            </div>
                            <!-- Column #2 - Provider's name -->
                            <div class="flex-20 align-start-center"
                                [matTooltip]="this.entitiesFacade.getProvidersFullName(agreement?.provider)"
                                (click)="this.agreementsExpanded.toggle(agreement.id)">
                                <span
                                    class="text-ellipsis">{{this.entitiesFacade.getProvidersFullName(agreement?.provider)}}</span>
                            </div>
                            <!-- Column #3 - Specialty -->
                            <div class="flex-18 align-start-center"
                                (click)="this.agreementsExpanded.toggle(agreement.id)"
                                [matTooltip]="this.entitiesFacade.getProviderSpecialties(agreement?.provider?.specialties)">
                                <span
                                    class="text-ellipsis">{{this.entitiesFacade.getProviderSpecialties(agreement?.provider?.specialties
                                    | slice: 0:2 )}}</span>
                            </div>
                            <!-- Column #4 - Provider's fee -->
                            <div class="flex-15 align-start-center"
                                (click)="this.agreementsExpanded.toggle(agreement.id)">
                                <span>{{agreement.providerFee | currency: 'ARS':'symbol':'1.2'}}</span>
                            </div>
                            <!-- Column #5 - Vigency -->
                            <div class="flex-15 flex-column align-start-center"
                                (click)="this.agreementsExpanded.toggle(agreement.id)">
                                <span>{{moment(agreement.fromDate).format('DD/MM/yyyy')}}</span>
                                <span>{{!!agreement.toDate ? ' - ' + moment(agreement.toDate).format('DD/MM/yyyy') : '
                                    en adelante'}}</span>
                            </div>
                            <!-- Column #6 - Actions -->
                            <div class="flex-row align-start-center flex-15">
                                <!-- Action delete -->
                                <!-- mat-icon-button-18x18 -->
                                <button class="" id="btn_delete_attentions" mat-icon-button
                                    [matTooltip]="'Eliminación de atenciones'"
                                    (click)="deleteAttentionsBatch(agreement)">
                                    <!-- mat-icon-18x18 -->
                                    <mat-icon class="" [svgIcon]="'Delete-enabled-primary-22x22'"></mat-icon>
                                </button>
                                <!-- Action add -->
                                <!-- mat-icon-button-18x18 -->
                                <!-- mat-icon-button-18x18 -->
                                <button class="" id="btn_add_attention" mat-icon-button
                                    [disabled]="this.loadingCreateAttention" [matTooltip]="'Agendar'"
                                    [color]="'primary'" (click)="onSelectedAgreement(agreement.id)">
                                    <!-- mat-icon-18x18 -->
                                    <mat-icon class="" [svgIcon]="'Add-attention-enabled-primary-22x22'"></mat-icon>
                                </button>
                            </div>
                        </div>
                        <!-- Attentions information-->
                        <div class="flex-column attentions-list"
                            [@detailExpand]="agreementsExpanded.selected.includes(agreement.id) ? 'expanded' : 'collapsed'"
                            [ngStyle]="{'pointer-events': !agreementsExpanded.selected.includes(agreement.id) ? 'none' : 'auto'}">
                            <!-- Attention row -->
                            <div class="attention-row"
                                *ngFor="let attention of agreement.attentions; trackBy: trackByAttentionId"
                                [@detailExpand]="agreementsExpanded.selected.includes(agreement.id) ? 'expanded' : 'collapsed'">

                                <!-- Column #1 - Attention date -->
                                <div class="flex-row flex-30 align-space-evenly-none">
                                    <span style="min-width: 16px; min-height: 1em;"><mat-icon style="cursor: pointer;"
                                            svgIcon="WarningCircle" class="mat-icon-small"
                                            matTooltip="{{this.overlapAdviceText(attention)}}"
                                            *ngIf="(!!this.overlapAdviceText(attention))"></mat-icon></span>
                                    <span style="min-width: 80px;"
                                        class="attention-information">{{this.getAttentionDayText(attention)}}</span>
                                </div>
                                <!-- Column #2 - Attention hour start/end -->
                                <div class="flex-30 align-center-center">
                                    <span class="attention-information">{{ this.practiceCountedByHours ?
                                        this.getAttentionHourSpan(attention) : 'Visita'}}</span>
                                    <span
                                        *ngIf="this.moment(attention.toDate).isAfter(attention.fromDate, 'day') && this.moment(attention.toDate).format('HH:mm') !== '00:00' ">
                                        (+{{moment(attention.toDate).startOf('day').diff(moment(attention.fromDate).startOf('day'),
                                        'day')}})</span>
                                </div>
                                <!-- Column #3 - Attention duration -->
                                <div class="flex-10 align-center-center">
                                    <span class="attention-information">{{this.practiceCountedByHours ?
                                        this.attentionsService.getHourQuantity(attention) : '1'}}</span>
                                </div>
                                <!-- Actions -->
                                <!-- fxLayoutGap="1em" -->
                                <div class="flex-row align-center-center">
                                    <!-- Edit button -->
                                    <!-- class="mat-icon-button-16x16" -->
                                    <button *ngIf="this.attentionsService.isEditable(attention)" class="mat-icon-small"
                                        id="btn_edit_attention_enabled" mat-icon-button [matTooltip]="'Editar'"
                                        (click)="this.editAttentionFromAgreementsGrid(attention);">
                                        <!-- class="mat-icon-16x16" -->
                                        <mat-icon [svgIcon]="'Edit-enabled-primary-16x16'"></mat-icon>
                                    </button>
                                    <!-- class="mat-icon-button-16x16" -->
                                    <button *ngIf="!this.attentionsService.isEditable(attention)" class="mat-icon-small"
                                        id="btn_edit_attention_disabled" mat-icon-button [matTooltip]="'Editar'">
                                        <!-- class="mat-icon-16x16"  -->
                                        <mat-icon [svgIcon]="'Edit-disabled-16x16'"></mat-icon>
                                    </button>
                                    <!-- Copy button -->
                                    <!-- class="mat-icon-button-16x16" -->
                                    <button *ngIf="this.attentionsService.isCopiable(attention)" class="mat-icon-small"
                                        id="btn_copy_attention_enabled" mat-icon-button [matTooltip]="'Copiar'"
                                        (click)="this.copyAttentionTo(attention)">
                                        <!-- class="mat-icon-16x16" -->
                                        <mat-icon [svgIcon]="'Copy-attention-enabled-primary-16x16'"></mat-icon>
                                    </button>
                                    <!-- class="mat-icon-button-16x16" -->
                                    <button *ngIf="!this.attentionsService.isCopiable(attention)" class="mat-icon-small"
                                        id="btn_copy_attention_disabled" mat-icon-button [matTooltip]="'Copiar'">
                                        <!-- class="mat-icon-16x16" -->
                                        <mat-icon [svgIcon]="'Copy-attention-disabled-16x16'"></mat-icon>
                                    </button>
                                    <!-- Delete button -->
                                    <!-- class="mat-icon-button-16x16" -->
                                    <button *ngIf="this.attentionsService.isDeletable(attention)" class="mat-icon-small"
                                        id="btn_delete_attention_enabled" mat-icon-button [matTooltip]="'Eliminar'"
                                        (click)="this.deleteAttentionFromAgreementsGrid(attention);">
                                        <!--  class="mat-icon-16x16" -->
                                        <mat-icon [svgIcon]="'Delete-enabled-primary-16x16'"></mat-icon>
                                    </button>
                                    <!-- class="mat-icon-button-16x16" -->
                                    <button *ngIf="!this.attentionsService.isDeletable(attention)"
                                        class="mat-icon-small" id="btn_delete_attention_disabled" mat-icon-button
                                        [matTooltip]="'Eliminar'">
                                        <!-- class="mat-icon-16x16" -->
                                        <mat-icon [svgIcon]="'Delete-disabled-16x16'"></mat-icon>
                                    </button>
                                    <!-- Replace agreement button -->
                                    <!-- class="mat-icon-button-16x16" -->
                                    <button
                                        *tenantFeature="'scheduleCase.replaceAgreementBtn'"
                                        class="mat-icon-small" id="btn_changeagreement_attention_enabled"
                                        mat-icon-button [matTooltip]="'Reemplazar acuerdo'"
                                        (click)="this.replaceAgreementAttentionFromAgreementsGrid(attention);">
                                        <!-- class="mat-icon-16x16" -->
                                        <mat-icon [svgIcon]="'ReplaceAgreement-enabled-primary-16x16'"></mat-icon>
                                    </button>
                                    <!-- class="mat-icon-button-16x16" -->
                                    <button
                                         *tenantFeature="'scheduleCase.replaceAgreementBtn'"
                                        class="mat-icon-small" id="btn_changeagreement_attention_disabled"
                                        mat-icon-button [matTooltip]="'Reemplazar acuerdo'">
                                        <!-- class="mat-icon-16x16" -->
                                        <mat-icon [svgIcon]="'ReplaceAgreement-disabled-16x16'"></mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Msg or calendar -->
            <div class="flex-57 flex-column p-2 mat-elevation-z2 calendar-container">
                <div *ngIf="!this.provisionFeeSelected; else thereIsProvisionFeeSelected"
                    class="align-center-center text-secondary-darker">
                    Aún no seleccionó prestación ni acuerdo prestacional para cargar agenda
                </div>
                <ng-template #thereIsProvisionFeeSelected>
                    <div class="flex-row flex-100" style="width:100%;" class="align-center-start">
                        <div class="flex-column">
                            <div class="flex-column schedule-form"
                                *ngIf="this.agreementSelected; else noAgreementSelected">
                                <div class="flex-row flex-100 align-start-start">
                                    @if (!!this.provisionFeeSelected &&
                                    this.provisionFeeSelected.practice?.restriction?.requiredTime) {
                                    <div class="flex-row flex-50 gap-0-25em" >
                                        <!-- Hora de ingreso -->
                                        <div class="flex-column flex-20 align-center-none">
                                            <span class="subtitle-3 text-primary-darker">Ingreso</span>
                                            <app-text-input
                                                [disabled]="!this.agreementSelected || loadingCreateAttention || !this.agreementSelected"
                                                class="flex-100 text-input" (changes)="validateTimeValid()" type="text"
                                                [name]="this.TIME_FROM" (keydown.enter)="$event.preventDefault()"
                                                [form]="this.scheduleForm">
                                            </app-text-input>
                                        </div>
                                        <!--Horario de salida-->
                                        <div class="flex-column flex-20 align-center-none"
                                            *ngIf="!!this.provisionFeeSelected && this.provisionFeeSelected.practice?.restriction?.requiredTime">
                                            <span class="subtitle-3 text-primary-darker">Salida</span>
                                            <div class="flex-row flex-100 align-start-center">
                                                <app-text-input
                                                    [disabled]="!this.agreementSelected || loadingCreateAttention || !this.agreementSelected"
                                                    class="flex-90 text-input" [selectAllOnClick]="true"
                                                    (changes)="changeHourFinish()" type="text" [name]="this.TIME_TO"
                                                    (keydown.enter)="$event.preventDefault()"
                                                    [form]="this.scheduleForm">
                                                </app-text-input>
                                            </div>
                                        </div>
                                        <!-- +1 -->
                                        <span *ngIf="isNextDay" class="subtitle-5 text-primary-darker" style="flex:2">+1 día</span>
                                        <!-- Cantidad de horas -->
                                        <div class="flex-column flex-40 align-center-none"
                                            *ngIf="!!this.provisionFeeSelected && this.provisionFeeSelected.practice?.restriction?.requiredTime">
                                            <span class="subtitle-3 text-primary-darker">Cantidad de horas</span>
                                            <div class="flex-100 flex-row gap-1em">
                                                <!-- HH -->
                                                <div class="flex-50 flex-row align-center-baseline">
                                                    <app-number-input class="flex-90 text-input"
                                                        (keydown.enter)="$event.preventDefault()"
                                                        [disabled]="loadingCreateAttention || !this.agreementSelected"
                                                        [minValue]="0" [name]="this.HOUR_DURATION"
                                                        (change)="durationChanged()" [form]="this.scheduleForm">
                                                    </app-number-input>
                                                    <span class="text-input flex-10">HH</span>
                                                </div>
                                                <!-- MM -->
                                                <div class="flex-50 flex-row align-center-baseline">
                                                    <app-number-input class="flex-90 text-input pls-1"
                                                        (keydown.enter)="$event.preventDefault()"
                                                        [disabled]="loadingCreateAttention || !this.agreementSelected"
                                                        [minValue]="0" [maxValue]="60" (change)="durationChanged()"
                                                        [name]="this.MINUTE_DURATION" [form]="this.scheduleForm">
                                                    </app-number-input>
                                                    <span class="text-input flex-10">MM</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    @if (!!this.provisionFeeSelected &&
                                    !this.provisionFeeSelected.practice?.restriction?.requiredTime) {
                                    <div class="flex-column align-center-none flex-50" >
                                        <span class="subtitle-3 text-primary-darker">Visitas por día</span>
                                        <app-select-input [name]="this.REPEAT_ATTENTION" [form]="this.scheduleForm"
                                            [disabled]="!this.datesToPostSelected[0] || loadingCreateAttention || !this.agreementSelected"
                                            [defaultValue]="this.defaultValueRepeatAttention.toString()"
                                            class="text-input" [elements]="this.repeatTimesAttention"
                                            [calculateId]="this.calculateIdAttentionRepeat"
                                            [calculateName]="this.calculateNameAttentionRepeat"
                                            (selected)="this.onSelectedAttentionRepeat($event)">
                                        </app-select-input>
                                    </div>
                                    }

                                    <!-- Se repite -->
                                    <div class="flex-row flex-1-1-auto align-start-start" >
                                        <div class="flex-column flex-60" >
                                            <!-- <mat-checkbox [disabled]="datesToPostSelected.length == 0" (change)="onChangeCheckRepeatSchedule($event)" [checked]="this.isRepeatSchedule">
                                                </mat-checkbox> -->
                                            <span class="subtitle-3 text-primary-darker">Se repite</span>
                                            <div class="flex-row pl-2">
                                                <mat-chip-listbox multiple
                                                    [ngStyle]="{'pointer-events':(datesToPostSelected.length == 0  || loadingCreateAttention || !this.agreementSelected ? 'none' : 'auto')}">
                                                    <mat-chip-option
                                                        *ngFor="let day of dayChipsSelected | keyvalue: asIsOrder; let i = index"
                                                        [disabled]="loadingCreateAttention || !this.agreementSelected"
                                                        [ngClass]="{'bg-primary' : isDayChipSelected(day.key), 'text-primary bg-white' : !isDayChipSelected(day.key)}"
                                                        class="repeat-day-chip no-avatar-size border-primary"
                                                        [selectable]="datesToPostSelected.length > 0"
                                                        [selected]="isDayChipSelected(day.key)"
                                                        (click)="selectDayChip(day)">
                                                        <span class="mat-small">{{day.key}}</span>
                                                    </mat-chip-option>
                                                </mat-chip-listbox>
                                            </div>
                                        </div>
                                        <div class="flex-column flex-40 align-start-start" >
                                            <span class="subtitle-3 text-primary-darker">Hasta</span>
                                            <div class="align-start-start" style="width: 100%;">
                                                <app-date-picker [name]="this.DATE_END_REPEAT" class=flex-100
                                                    [form]="this.scheduleForm" class="flex-100 text-input"
                                                    [disabled]="loadingCreateAttention || !this.agreementSelected"
                                                    [placeholder]="'Fecha de finalización de la repetición'"
                                                    (onDateChange)="setDatePicker($event)" [min]="this.minDate"
                                                    [max]="this.maxDate">
                                                </app-date-picker>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex-row flex-100 align-space-between-center">
                                    <div class="flex-column align-center-none flex-30">
                                        <span class="subtitle-3 text-primary-darker">Estado de la atención</span>
                                        <app-select-input [name]="this.STATE_ATTENTION" class="text-input" 
                                            [form]="this.scheduleForm" [elements]="this.attentionStatesPost"
                                            (selected)="this.onSelectedStateAttention($event)"
                                            [calculateId]="this.calculateIdState"
                                            [calculateName]="this.calculateNameState">
                                        </app-select-input>
                                    </div>
                                    <div class="flex-row align-center-center">
                                        <button
                                            [disabled]="this.datesToPostSelected.length < 1  || loadingCreateAttention || !this.agreementSelected"
                                            mat-button (click)="onCleanAttentions()">
                                            <mat-icon class="text-secondary">close</mat-icon>
                                            <span class="text-secondary-darker">
                                                Borrar días seleccionados ({{this.datesToPostSelected.length}})
                                            </span>
                                        </button>
                                    </div>
                                    <div class="align-end-center">
                                        <button mat-flat-button [color]="'primary'" class="medium"
                                            [disabled]="!this.scheduleForm.valid || loadingCreateAttention || !(this.datesToPostSelected.length > 0)"
                                            (click)="onCreateAttentionV2(true)">
                                            <span *ngIf="!loadingCreateAttention; else loadingConfirm">
                                                GUARDAR
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-column gap-1em">
                                <!-- Top bar calendar -->
                                <div class="flex-row align-space-between-center">
                                    <div class="flex-20">
                                        <mat-form-field style="height: 40px !important;" class="flex-100"
                                            appearance="outline">
                                            <mat-select id="cmb_period_view" [(value)]="this.view"
                                                (selectionChange)="this.selectView($event)" class="subtitle-2">
                                                <mat-option value="{{CalendarView.Month}}">
                                                    Mes
                                                </mat-option>
                                                <mat-option value="{{CalendarView.Week}}">
                                                    Semana
                                                </mat-option>
                                                <mat-option value="{{CalendarView.Day}}">
                                                    Día
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="flex-row align-center-center flex-80">
                                        <button id="btn_previous" mat-icon-button id="arrowLeftButton"
                                            mwlCalendarPreviousView [view]="view"
                                            (click)="clickonCalendarPreviousNextView()" [(viewDate)]="viewDate"
                                            [color]="'primary'"
                                            [disabled]="buttonsNewDateScheduleNavigator?.buttonLeftDisabled">
                                            <mat-icon
                                                [ngClass]="{'text-secondary-darker':!buttonsNewDateScheduleNavigator?.buttonLeftDisabled, 'text-secondary-lighter':buttonsNewDateScheduleNavigator?.buttonLeftDisabled }">keyboard_arrow_left</mat-icon>
                                        </button>
                                        <div class="align-center-center">
                                            <span class="subtitle-2 text-secondary-darker">
                                                <!-- First day is Monday -> 1 -->
                                                {{ (viewDate | calendarDate:(view + 'ViewTitle'):'es-AR': 1) | titlecase
                                                }}
                                            </span>
                                        </div>
                                        <button id="btn_next" mat-icon-button id="arrowRightButton" mwlCalendarNextView
                                            [view]="view" (click)="clickonCalendarPreviousNextView()"
                                            [(viewDate)]="viewDate" [color]="'primary'"
                                            [disabled]="buttonsNewDateScheduleNavigator?.buttonRightDisabled">
                                            <mat-icon
                                                [ngClass]="{'text-secondary-darker':!buttonsNewDateScheduleNavigator?.buttonRightDisabled, 'text-secondary-lighter':buttonsNewDateScheduleNavigator?.buttonRightDisabled }">keyboard_arrow_right</mat-icon>
                                        </button>
                                    </div>
                                </div>
                                <mat-error
                                    *ngIf=" this.scheduleForm.errors && (this.scheduleForm.dirty || this.scheduleForm.touched)"
                                    class="mls-3 flex" style="display: flex; align-items: center; gap: 4px;">
                                    <mat-icon svgIcon="WarningCircle" style="flex-shrink: 0;"></mat-icon>
                                    <span class="text-warn">{{ objectValues(this.scheduleForm.errors)[0] }}</span>
                                </mat-error>
                                <!-- Calendar -->
                                <div [ngSwitch]="view">
                                    <!-- (eventTimesChanged)="eventTimesChanged($event)" -->
                                    <mwl-calendar-month-view [viewDate]="viewDate" [refresh]="refresh"
                                        [events]="monthEvents" [locale]="'es-AR'" [cellTemplate]="customTemplate"
                                        *ngSwitchCase="CalendarView.Month"
                                        (dayClicked)="onSelectDate(moment($event.day.date))" [weekStartsOn]="1">
                                    </mwl-calendar-month-view>
                                    <mwl-calendar-week-view *ngSwitchCase="CalendarView.Week" [viewDate]="viewDateX"
                                        [events]="events" [refresh]="refresh"
                                        (beforeViewRender)="applyDateSelectionPolicy($event)"
                                        (eventClicked)="eventClicked($event.event)" [weekStartsOn]="1">
                                    </mwl-calendar-week-view>
                                    <mwl-calendar-day-view *ngSwitchCase="CalendarView.Day" [viewDate]="viewDateX"
                                        [events]="events" [refresh]="refresh"
                                        (beforeViewRender)="applyDateSelectionPolicy($event)"
                                        (eventClicked)="eventClicked($event.event)">
                                    </mwl-calendar-day-view>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
        <!-- Buttons -->
        <div class="mts-5 gap-15px flex-row align-center-center">
            <button mat-stroked-button [color]="'primary'" (click)="onClickCloseDialog()"
                [disabled]="loadingCreateAttention">
                <span *ngIf="!loadingCreateAttention; else loadingConfirm">
                    CERRAR
                </span>
            </button>
        </div>
    </form>
    }
</ng-template>

<ng-template #loadingConfirm>
    <mat-icon>
        <mat-spinner color="accent" diameter="20">
        </mat-spinner>
    </mat-icon>
</ng-template>

<ng-template #loading>
    <app-spinner class="flex-100 align-start"></app-spinner>
</ng-template>

<ng-template #customTemplate let-day="day" let-locale="locale">
    <!-- cal-cell-day -->
    <div *ngIf="day.events" class="flex-100 align-space-between-center flex-column" style="max-width: 100px;"
        [ngClass]="{'bg-primary-lighter': isSelectedDate(moment(day.date)),'disabled-day': disableDay(day.date)}">

        <!-- Header: Día y badge -->
        <div class="flex-100 cal-cell-top flex-row">
            <span class="flex-60 align-end-center cal-day-number" style="margin-left:2vh ;padding-right:2vh ;">{{
                day.date | calendarDate:'monthViewDayNumber':locale }}</span>
            <div class="flex-40 align-end-center">
                @if(day.badgeTotal > 0) {
                <span class="cal-day-badge bg-primary-lighter text-primary">
                    {{ day.badgeTotal }}
                </span>
                }
            </div>
        </div>

        <!-- Lista de eventos -->
        <div
            style="display: flex; gap: 2%; flex-direction: column; min-height: 100% !important; padding-bottom: 10px;align-self: center;">
            <ng-container *ngFor="let event of day.events; let i = index; trackBy: trackByEventIndex">
                <div *ngIf="i < 3 || (i === 3 && day.events.length == 3)" (click)="eventClicked($event, event)"
                    class="event-label flex-row align-center-center gap-0-5em"
                    [style.width.vh]="event.meta.attention.type === AttentionType.MODULE ? '8' : '13'"
                    [style.background-color]="event.meta.attention.type === AttentionType.MODULE ? '#FF8A00' : event?.color?.primary"
                    #targetElement>
                    <!--Evento comienza otro  -->
                    <mat-icon class="text-white" style="padding-left: 1px;padding-top: 15px"
                        *ngIf="event.meta.isNotOneDayEvent && calendarCaseService.eventStartsBeforeDaySelected(event, day.date)">
                        arrow_back
                    </mat-icon>
                    <!-- Nombre del prestador -->
                    <span [matTooltip]="event?.title" class="flex text-white mls-1 text-ellipsis pt-1"
                        [style.justify-content]="event.meta.attention.type === AttentionType.MODULE ? 'center' : 'flex-start'">
                        @if(event.meta.attention.type === AttentionType.MODULE){
                        <mat-icon style=" width: 14px;height: 14px;  font-size: 14px;"
                            [svgIcon]="'module-attention-scheduled'"></mat-icon>
                        }@else{
                        {{ event?.title }}
                        }
                    </span>
                    <!-- Icono de reloj -->
                    <mat-icon svgIcon="Watch-16x16" class="text-white" [style.width.vh]="'5'"
                        [matTooltip]="calendarCaseService.getHoursTooltip(event)"
                        *ngIf="calendarCaseService.practiceCountedByHours(event?.meta?.attention?.practice)">
                    </mat-icon>
                    <!-- Evento termina después -->
                    <mat-icon class="text-white xxs mr-5" style="padding-top: 15px;"
                        *ngIf="event.meta.isNotOneDayEvent && calendarCaseService.eventEndsAfterDaySelected(event, day.date)">
                        arrow_forward
                    </mat-icon>
                    <!-- Estado de la atención -->
                    <span [matTooltip]="event?.meta?.attention?.state?.name"
                        [style.width.vh]="event.meta.attention.type === AttentionType.MODULE ? '5' : '3'" [ngStyle]="{
                                          'background-color': calendarCaseService.getColor(event?.meta?.attention?.state?.id)
                                      }" class="flex state-initial text-white border-radius align-center-center">
                        {{ event?.meta?.attention?.state?.name | firstLetterWordsIntoString }}
                    </span>

                </div>
            </ng-container>

            <!-- Más eventos -->
            <div *ngIf="day.events.length >  3" (click)="onClickSeeMoreAttentions($event, day)" class="flex-80">
                <span class="flex more-events pxs-1">{{ day.events.length - 3}} más</span>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #extraAttentionsTemplate>
    <ng-container>
        <div class="flex-column align-center-center mb-5">
            <span class="text-secondary-darker headline-2">{{this.dayOpened.format('dddd') | uppercase}}</span>
            <span class="text-secondary-darker headline-2">{{this.dayOpened.format('DD')}}</span>
        </div>
    </ng-container>
    <ng-container>
        <div *ngFor="let event of this.extraDayAttentions" class="extra-attentions-event-label"
            [style.background-color]="event?.color?.primary" (click)="handleEvent('Clicked', event)">
            <div class="flex-row gap-0-5em" style="cursor: pointer;justify-content: space-between; align-items: center;"
                (click)="eventClicked($event, event)">
                <mat-icon class="flex-10 text-white extra-small"
                    *ngIf="event.meta.isNotOneDayEvent && this.calendarCaseService.eventStartsBeforeDaySelected(event, this.dayOpened)">arrow_back</mat-icon>
                <span class="flex-1 text-white text-ellipsis" [matTooltip]="event?.title">{{event?.title}}</span>
                <mat-icon class="flex-10  text-white extra-small"
                    *ngIf="event.meta.isNotOneDayEvent && this.calendarCaseService.eventEndsAfterDaySelected(event, this.dayOpened)">arrow_forward</mat-icon>
                <mat-icon class="flex-10 text-white extra-small"
                    [matTooltip]="calendarCaseService.getHoursTooltip(event)"
                    *ngIf="calendarCaseService.practiceCountedByHours(event?.meta?.attention?.practice)"> query_builder
                </mat-icon>
                <span class="flex-10  state-initial text-white border-radius align-center-center"
                    style="width: 25px !important; height:25px !important; display: flex;font-size: 12px;"
                    [ngStyle]="{'background-color': calendarCaseService.getColor(event?.meta?.attention?.state?.id)}"
                    [matTooltip]="event?.meta?.attention?.state?.name">{{event?.meta?.attention?.state?.name |
                    firstLetterWordsIntoString}}</span>
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #noAgreementSelected>
    <!-- style="min-height: 50px;" -->
    <div class="flex-row align-center-center gap-0-5em mbs-3">
        <span class="text-secondary-darker">Para la carga de agenda, seleccione un acuerdo prestacional con el
            símbolo</span>
        <mat-icon class="mat-icon-22x22" [svgIcon]="'Add-attention-default-22x22'"></mat-icon>
    </div>
</ng-template>

<ng-template #deleteWizardAttentions>
    <app-attentions-delete-wizard [caseId]="this.case.id" [provisionAgreements]="this.provisionAgreements"
        [provisionFees]="[this.provisionFeeSelected]" (onClickCancelWizard)="clickCancelDeleteWizard()">
    </app-attentions-delete-wizard>
</ng-template>

<ng-template #editAttentionDialogTemplate>
    <app-attention-edit [attention]=attentionToEdit (closeDialog)="closeDialogAttentionEdit()"
        [lastDate]="fromProviderSchedule || isModulesFlow ? null : selectLastDate()"
        (refreshDataFiltered)="onAttentionEditRefresh()" (onEventDelete)="onClickDeleteAttention($event)"
        [mode]="editMode" [flow]="fromProviderSchedule ? 'fromProviderSchedule' : ''">
    </app-attention-edit>
</ng-template>